import DonationCompleteRoute from '@/pages/DonationCompleteRoute.vue'
import DonationRoute from '@/pages/DonationRoute.vue'
import FlowDetailsRoute from '@/pages/FlowDetailsRoute.vue'
import PaymentReturnRoute from '@/pages/PaymentReturnRoute.vue'

import type { RouteDefinition } from '@/router'

export const routes: RouteDefinition[] = [
  {
    path: '/flows/:id',
    component: FlowDetailsRoute,
  },
  {
    path: '/donations/:id',
    name: 'donation',
    component: DonationRoute,
  },
  {
    path: '/donations/:id/complete',
    name: 'donation-complete',
    component: DonationCompleteRoute,
    meta: {
      title: 'Donation Complete',
    },
  },
  {
    path: '/payment-return',
    name: 'payment-return',
    component: PaymentReturnRoute,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundPage',
    component: () => import('@/pages/NotFoundPage.vue'),
  },
]
